import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::presign
* @see app/Http/Controllers/Works/Images/WorkImageController.php:50
* @route '/works/{work}/images/presign'
*/
export const presign = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: presign.url(args, options),
    method: 'post',
})

presign.definition = {
    methods: ["post"],
    url: '/works/{work}/images/presign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::presign
* @see app/Http/Controllers/Works/Images/WorkImageController.php:50
* @route '/works/{work}/images/presign'
*/
presign.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return presign.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::presign
* @see app/Http/Controllers/Works/Images/WorkImageController.php:50
* @route '/works/{work}/images/presign'
*/
presign.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: presign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::presign
* @see app/Http/Controllers/Works/Images/WorkImageController.php:50
* @route '/works/{work}/images/presign'
*/
const presignForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: presign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::presign
* @see app/Http/Controllers/Works/Images/WorkImageController.php:50
* @route '/works/{work}/images/presign'
*/
presignForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: presign.url(args, options),
    method: 'post',
})

presign.form = presignForm

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::storeFile
* @see app/Http/Controllers/Works/Images/WorkImageController.php:72
* @route '/works/{work}/images/store-file'
*/
export const storeFile = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeFile.url(args, options),
    method: 'post',
})

storeFile.definition = {
    methods: ["post"],
    url: '/works/{work}/images/store-file',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::storeFile
* @see app/Http/Controllers/Works/Images/WorkImageController.php:72
* @route '/works/{work}/images/store-file'
*/
storeFile.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return storeFile.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::storeFile
* @see app/Http/Controllers/Works/Images/WorkImageController.php:72
* @route '/works/{work}/images/store-file'
*/
storeFile.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeFile.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::storeFile
* @see app/Http/Controllers/Works/Images/WorkImageController.php:72
* @route '/works/{work}/images/store-file'
*/
const storeFileForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: storeFile.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::storeFile
* @see app/Http/Controllers/Works/Images/WorkImageController.php:72
* @route '/works/{work}/images/store-file'
*/
storeFileForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: storeFile.url(args, options),
    method: 'post',
})

storeFile.form = storeFileForm

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::attach
* @see app/Http/Controllers/Works/Images/WorkImageController.php:91
* @route '/works/{work}/images/attach'
*/
export const attach = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: attach.url(args, options),
    method: 'post',
})

attach.definition = {
    methods: ["post"],
    url: '/works/{work}/images/attach',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::attach
* @see app/Http/Controllers/Works/Images/WorkImageController.php:91
* @route '/works/{work}/images/attach'
*/
attach.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return attach.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::attach
* @see app/Http/Controllers/Works/Images/WorkImageController.php:91
* @route '/works/{work}/images/attach'
*/
attach.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: attach.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::attach
* @see app/Http/Controllers/Works/Images/WorkImageController.php:91
* @route '/works/{work}/images/attach'
*/
const attachForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: attach.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::attach
* @see app/Http/Controllers/Works/Images/WorkImageController.php:91
* @route '/works/{work}/images/attach'
*/
attachForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: attach.url(args, options),
    method: 'post',
})

attach.form = attachForm

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::destroy
* @see app/Http/Controllers/Works/Images/WorkImageController.php:168
* @route '/works/{work}/images/{image}'
*/
export const destroy = (args: { work: string | { slug: string }, image: string | number | { id: string | number } } | [work: string | { slug: string }, image: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/works/{work}/images/{image}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::destroy
* @see app/Http/Controllers/Works/Images/WorkImageController.php:168
* @route '/works/{work}/images/{image}'
*/
destroy.url = (args: { work: string | { slug: string }, image: string | number | { id: string | number } } | [work: string | { slug: string }, image: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            image: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        image: typeof args.image === 'object'
        ? args.image.id
        : args.image,
    }

    return destroy.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{image}', parsedArgs.image.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::destroy
* @see app/Http/Controllers/Works/Images/WorkImageController.php:168
* @route '/works/{work}/images/{image}'
*/
destroy.delete = (args: { work: string | { slug: string }, image: string | number | { id: string | number } } | [work: string | { slug: string }, image: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::destroy
* @see app/Http/Controllers/Works/Images/WorkImageController.php:168
* @route '/works/{work}/images/{image}'
*/
const destroyForm = (args: { work: string | { slug: string }, image: string | number | { id: string | number } } | [work: string | { slug: string }, image: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\Images\WorkImageController::destroy
* @see app/Http/Controllers/Works/Images/WorkImageController.php:168
* @route '/works/{work}/images/{image}'
*/
destroyForm.delete = (args: { work: string | { slug: string }, image: string | number | { id: string | number } } | [work: string | { slug: string }, image: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const images = {
    presign: Object.assign(presign, presign),
    storeFile: Object.assign(storeFile, storeFile),
    attach: Object.assign(attach, attach),
    destroy: Object.assign(destroy, destroy),
}

export default images